import { Injectable } from "@angular/core";
import { City, Country } from "../@core/models/country.model";
import countries from '../../assets/mock/countries.json';
import { ApplicationRoutes } from "../@core/routes/application-routes.const";
import { ApiClientService } from "../@core/services/api-client.service";

@Injectable({
    providedIn: 'root'
})

export class CountryService {
    lookupRoutes = ApplicationRoutes.Lookups;


    constructor(private apiClient: ApiClientService) { }

    getCountries() {
        return this.apiClient.get(`${ApplicationRoutes.Lookups.CountriesDropdown}`);
    }

    getRegions(countryId?: number) {
        let query = countryId ? `?countryId=${countryId}` : '';
        return this.apiClient.get(`${ApplicationRoutes.Lookups.RegionsDropdown}${query}`);
    }

    getCities(countryId?: number, regionId?: number): any {
        let query = countryId ? `countryId=${countryId}` : '';
        if(regionId) query += `&regionId=${regionId}`;
        return this.apiClient.get(`${ApplicationRoutes.Lookups.CitiesDropdown}?${query}`);
    }

    GetCountryDetails(id: number) {
        return this.apiClient.get(this.lookupRoutes.Country(id));
    }

    GetRegionDetails(id: number) {
        return this.apiClient.get(this.lookupRoutes.Region(id));
    }

    GetCityDetails(id: number) {
        return this.apiClient.get(this.lookupRoutes.City(id));
    }

}